import React from "react";
import { FiCheckCircle } from "react-icons/fi";
import "./AIJobOfferSection.css";

const AIJobOfferSection = () => {
  return (
    <div className="aios-wrapper">
      <div className="aios-container">

        {/* LEFT SIDE CONTENT */}
        <div className="aios-left">
          <p className="aios-subtitle">PROCESSING OF ADVERTISEMENT</p>

          <h1 className="aios-title">
            <span className="aios-title-dark">Create job offers</span>{" "}
            <span className="aios-title-highlight">with AI</span>
          </h1>

          <p className="aios-description">
            Create a profile of the ideal candidate for the advertised positions.  
            AI will prepare an optimized job offer for you.
          </p>

          {/* Feature List */}
          <div className="aios-features">
            <div className="aios-feature-item">
              <FiCheckCircle className="aios-icon" />
              <span>Customizable AI job ad design</span>
            </div>

            <div className="aios-feature-item">
              <FiCheckCircle className="aios-icon" />
              <span>Automated creation of job offers</span>
            </div>

            <div className="aios-feature-item">
              <FiCheckCircle className="aios-icon" />
              <span>Templates for different job positions</span>
            </div>
          </div>

          {/* Buttons */}
          <div className="aios-buttons">
            <button className="aios-btn-primary">Try it for free</button>
            <button className="aios-btn-secondary">Request demo</button>
          </div>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <div className="aios-right">
          <img
            src="/images/recu2.png"
            alt="AI Job Builder"
            className="aios-image"
          />
        </div>

      </div>
    </div>
  );
};

export default AIJobOfferSection;
